<div class="page-wrapper">
  <div class="page-header-with-back" style="display: flex; align-items: center; gap: 15px; margin-bottom: 24px;">
    <button type="button" class="form-back-btn" (click)="goBack()" style="background: white; border: 1px solid #eaeaea; font-size: 18px; cursor: pointer; color: #0a376e; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; border-radius: 8px; transition: all 0.3s ease; box-shadow: 0 2px 4px rgba(0,0,0,0.02);">
      <i class="bi" [ngClass]="userLang === 'ar' ? 'bi-chevron-right' : 'bi-chevron-left'"></i>
    </button>
    <div class="page-title" style="margin-bottom: 0;">{{ isEditMode ? ('Edit Job Position' | translate) : ('Create New Job Position' | translate) }}</div>
  </div>

  <form [formGroup]="form" (ngSubmit)="onSubmit()">

    <!-- ══ Basic Info ══ -->
    <div class="section-card">

      <!-- Position Title -->
      <div class="field-group">
        <label class="field-label">{{ 'Position Title' | translate }}</label>
        <input class="form-input"
          [class.input-error]="form.get('jobPosition')?.invalid && form.get('jobPosition')?.touched"
          formControlName="jobPosition" [placeholder]="'e.g., Software Engineer' | translate" type="text" />
        <span class="error-msg" *ngIf="form.get('jobPosition')?.invalid && form.get('jobPosition')?.touched">
          {{ 'Position title is required.' | translate }}
        </span>
      </div>

      <!-- Department / Team -->
      <div class="field-group">
        <label class="field-label">{{ 'Department / Team' | translate }}</label>
        <div class="custom-select" [class.open]="openDropdowns['department']">
          <div class="custom-select-trigger form-input"
            [class.input-error]="form.get('department')?.invalid && form.get('department')?.touched"
            (click)="toggleDropdown('department', $event)">
            <span [class.select-placeholder]="!form.get('department')?.value">{{ form.get('department')?.value ? (form.get('department')?.value | translate) : ('Choose Department / Team' | translate) }}</span>
            <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <div class="custom-select-dropdown" *ngIf="openDropdowns['department']" (click)="$event.stopPropagation()">
            <div *ngFor="let d of data.departments" class="custom-select-option"
              [class.option-active]="form.get('department')?.value === d"
              (click)="selectDropdownOption('department', d, $event)">
              {{ d | translate }}
            </div>
          </div>
        </div>
        <span class="error-msg" *ngIf="form.get('department')?.invalid && form.get('department')?.touched">
          {{ 'Please select a department.' | translate }}
        </span>
      </div>

      <!-- Job Level -->
      <div class="field-group">
        <label class="field-label">{{ 'Job level' | translate }}</label>
        <div class="custom-select" [class.open]="openDropdowns['careerLevel']">
          <div class="custom-select-trigger form-input"
            [class.input-error]="form.get('careerLevel')?.invalid && form.get('careerLevel')?.touched"
            (click)="toggleDropdown('careerLevel', $event)">
            <span [class.select-placeholder]="!form.get('careerLevel')?.value">{{ getCareerLevelLabel() }}</span>
            <svg class="select-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
              stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
          <div class="custom-select-dropdown" *ngIf="openDropdowns['careerLevel']" (click)="$event.stopPropagation()">
            <div *ngFor="let cl of data.careerLevels" class="custom-select-option"
              [class.option-active]="form.get('careerLevel')?.value === cl.label"
              (click)="selectDropdownOption('careerLevel', cl.label, $event)">
              {{ cl.label | translate }}{{ cl.sub ? ' (' + (cl.sub | translate) + ')' : '' }}
            </div>
          </div>
        </div>
        <span class="error-msg" *ngIf="form.get('careerLevel')?.invalid && form.get('careerLevel')?.touched">
          {{ 'Please select a job level.' | translate }}
        </span>
      </div>

    </div>

    <!-- ══ Submit ══ -->
    <div class="form-actions">
      <button type="submit" class="create-btn" [disabled]="isLoading">
        <span *ngIf="!isLoading">{{ isEditMode ? ('Save Changes' | translate) : ('Create' | translate) }}</span>
        <span *ngIf="isLoading" class="spinner"></span>
      </button>
    </div>

  </form>
</div>